import ReactGA from "react-ga4";

export const initGA = () => {
      ReactGA.initialize("G-BS7SVJLQ1V", {
        testMode: process.env.NODE_ENV === "development",
      });
}